import * as React from "react";
import { nest } from "d3-collection";
import { extent } from "d3";
import { scaleLinear, scaleTime } from "d3-scale";
import { compose, scaleQual12, scaleQual6, first } from "sszvis";
import { AxisXTime, AxisY } from "../sszvis-components/Axis";
import { Line } from "../sszvis-components/Line";
import { H4 } from "../theme/text";
import { css } from "emotion";
import { spacing } from "../theme/layout";
export class MiniLineChart extends React.Component {
    constructor() {
        super(...arguments);
        this.calculateScales = () => {
            const { unit, getTimeValue, getLocation, getFacet, getMeasureValue, locations, selectedGeoEntity, width, margins, metadata, data, timeScale, valueScale, colorScale, title, showYAxis } = this.props;
            const height = width * 0.5;
            const chartWidth = width - margins.left - margins.right;
            const chartHeight = height - margins.top - margins.bottom;
            const dimTimeDomain = extent(data, getTimeValue);
            const dimValueDomain = extent(data, getMeasureValue);
            const _timeScale = timeScale
                ? timeScale
                : scaleTime()
                    .domain(dimTimeDomain)
                    .range([0, chartWidth]);
            const _valueScale = valueScale
                ? valueScale
                : scaleLinear()
                    .domain([0, dimValueDomain[1]]) // FIXME: 0 or min value ?
                    .range([chartHeight, 0]);
            const _colorScale = colorScale
                ? colorScale
                : (metadata.facets.length > 6 ? scaleQual12() : scaleQual6()).domain(metadata.facets.map(f => f.label));
            return {
                height,
                chartWidth,
                chartHeight,
                timeScale: _timeScale,
                valueScale: _valueScale,
                colorScale: _colorScale
            };
        };
    }
    render() {
        const { unit, getTimeValue, getLocation, getFacet, getMeasureValue, locations, width, margins, metadata, data, title, showYAxis, } = this.props;
        const facets = metadata.facets;
        const lineData = nest()
            .key(getFacet)
            .entries(data.sort((a, b) => {
            return getTimeValue(a).getTime() - getTimeValue(b).getTime();
        }))
            .map(({ values }) => values);
        const { timeScale, valueScale, colorScale, height, chartHeight } = this.calculateScales();
        return (<div>
        {title && (<H4 className={css `
              margin-left: ${margins.left}px;
              ${spacing.mt3};
            `}>
            {title}
          </H4>)}
        <svg width={width} height={height}>
          <Line x={compose(timeScale, getTimeValue)} y={compose(valueScale, getMeasureValue)} stroke={compose(colorScale, getFacet, first)} strokeWidth={2} valuesAccessor={(d) => d} data={lineData} gProps={{
            transform: `translate(${margins.left}, ${margins.top})`
        }}/>
          <AxisXTime scale={timeScale} orient="bottom" ticks={5} gProps={{
            transform: `translate(${margins.left}, ${chartHeight +
                margins.top})`
        }}/>
          {showYAxis && (<AxisY scale={valueScale} title={unit} orient="right" contour ticks={5} gProps={{
            transform: `translate(${margins.left}, ${margins.top})`
        }}/>)}
        </svg>
      </div>);
    }
}
MiniLineChart.defaultProps = {
    showYAxis: false
};



// WEBPACK FOOTER //
// ./src/detail/MiniLineChart.tsx